import {
  CouponDetailDto,
  CouponDetailDtoRedeemStatusEnum,
} from '../../../generated/api';
import { assertNever } from '../../../utils/typeHelper';
import { apiServerTimeToDateObject } from '../../api-model-utils/apiServerTimeToDateObject';
import { UniversalRedeemableCoupon } from '../../models/coupon';
import { couponItemToUniversalCoupon } from '../couponItemToUniversalCoupon';

export function couponDetailDtoToUniversalRedeemableCoupon(
  dto: CouponDetailDto,
): null | UniversalRedeemableCoupon {
  const coupon = couponItemToUniversalCoupon(dto.coupon);
  if (!coupon) return null;
  switch (dto.redeemStatus) {
    case CouponDetailDtoRedeemStatusEnum.Nonredeemable:
      return {
        status: UniversalRedeemableCoupon.Status.Nonredeemable,
        couponId: dto.couponId,
        coupon,
        reason: dto.reason ?? '',
      };
    case CouponDetailDtoRedeemStatusEnum.Redeemable:
      return {
        status: UniversalRedeemableCoupon.Status.Redeemable,
        couponId: dto.couponId,
        coupon,
      };
    case CouponDetailDtoRedeemStatusEnum.Redeemed:
      return {
        status: UniversalRedeemableCoupon.Status.Redeemed,
        couponId: dto.couponId,
        coupon,
        redeemedCouponId: dto.redeemedCouponId!,
        usedAt: dto.redeemedCoupon?.usedAt
          ? apiServerTimeToDateObject(dto.redeemedCoupon.usedAt)
          : undefined,
      };
    default:
      assertNever(dto.redeemStatus);
  }
}
